// extracted by mini-css-extract-plugin
export default {"root":"h83BC3","postPublishDate":"cIFKTM","authorLink":"H45tQu","authorName":"gH3Y5r","authorImageWrapper":"dwTSJu","authorAvatar":"iPNYVk","postReadingTime":"Epkner"};